import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { memo, useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { IsoToDateWithoutTime, convertToISO } from "../../../../CommonFunction/IsoDateTime";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import {
  CREATE_LOAD_MUTATION,
  DELETE_LOAD_MUTATION,
  EDIT_LOAD,
  Get_Load_By_Id,
  Get_Vehicle_Category,
  Get_Vehicle_Category_By_Id,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import DocumentuploadSection from "../../../Templets/DocumentuploadSection/DocumentuploadSection";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import Button from "../../Button/Button";
import FirstSectionModal from "../../CommonMultiSelectComponent/FirstSelectionModal";
import { ErrorToast, SuccessToast, WarningToast } from "../../ToastComponent/RectHotToast";
import { DocUpload, Loadfilds } from "./AdddLoad.Config";
import "./Addload.scss";
import Addloadsection from "./Addloadsection/Addloadsection";
import BidDetails from "./Bidding";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import { useModalContext } from "../../Reactportal/ModalContext";
import { useEventListener } from "usehooks-ts";
import Addload from "../AddLoad/Addload";

const AddMyload = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Load");
  const [isFirstLoad, setFirstLoad] = useState(false);
  const Form_Key = "Loads";
  const { pushModal, popModal } = useModalContext();
  let formRef = useRef({});
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const Tab = useSelector((store) => store.SelectedTabData.tab);
  const path = window.location.pathname;
  console.log(path, "path");
  console.log(Tab, "path");
  const [isTMSLoadBoardPage, setIsTMSLoadBoardPage] = useState(true);
  const [toggle, settoggle] = useState(show);
  const [alldata, setalldata] = useState({});
  const [notesdata, setNotesdata] = useState("");
  const [loadType, setLoadType] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalWeight, setTotalWeight] = useState("");
  const fielddataRedux = useSelector((store) => store?.UniqueTableReducer);
  const fielddata = fielddataRedux?.[`My_Loads`]?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState();
  const [openSelectionModal, setOpenSelectionModal] = useState(false);
  const [selectedBranches, setSelectedBranch] = useState({});
  const [showBidModal, setShowBidModal] = useState(false);
  const [isVehicleCateSelected, setIsVehicleCateSelected] = useState(false);
  const [showCopyLoadModal, setShowCopyLoadModal] = useState(false);
  const FormData = useSelector((store) => store.FormFieldData);
  const [fileData, setFileData] = useState({});
  const [showVehicleCategory, setShowVehicleCategory] = useState();
  const [createLoad, { loading: CreateLoads, error }] = useMutation(CREATE_LOAD_MUTATION, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const { data: vehicleCategoryData } = useQuery(Get_Vehicle_Category, {
    variables: {
      keyword: "",
    },
    fetchPolicy: "network-only",
  });

  const [editLoad, { loading: EditLoading }] = useMutation(EDIT_LOAD, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  // const [AuditLoad, { loading: AuditLoads }] = useMutation(Audit_Load_MUTATION);
  const [deleteLoads, { loading: DeleteLoads }] = useMutation(DELETE_LOAD_MUTATION);

  const dispatch = useDispatch();

  const [GetLoadById] = useLazyQuery(Get_Load_By_Id, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    fetchPolicy: "network-only",
  });
  const [formErrors, setFormErrors] = useState({});
  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };
  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);

    if (!Error || TypeOfPortal === "Delete") {
      submit();
    }
  };
  formRef.current.GetFileValues = (values) => {
    console.log(values);
    setFileData((prev) => {
      return { ...prev, ...values };
    });
  };

  useEffect(() => {
    const flag = path === "/LoadBoard" && (Tab === "Market" || Tab === "Preferred");
    setIsTMSLoadBoardPage(flag);
  }, []);

  useEffect(() => {
    dispatch({
      type: "SearchMasterData",
      payload: {
        UserId: { _id: fielddata?.User_Id },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddata]);

  useEffect(() => {
    let res = hasAnyVehicle(selectedBranches);
    setIsVehicleCateSelected(res);
  }, [selectedBranches]);

  useEffect(() => {
    if ((TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") || TypeOfPortal === "Copy") {
      GetLoadById({
        variables: {
          ID: fielddata?._id,
        },
      }).then(({ data }) => {
        if (TypeOfPortal !== "Copy") {
          let LoadData = { ...data?.loadByID[0] };
          if (LoadData?.Loading_Date) {
            LoadData.Loading_Date = IsoToDateWithoutTime(LoadData.Loading_Date);
          }
          setTotalWeight(data?.loadByID[0]?.Total_Weight);
          // setLoadPostType(data?.loadByID[0]?.Load_Post_Type)
          let vehicleCategory = transformArrayToObj(LoadData?.VehicleCategoryGroupData);
          console.log(vehicleCategory);
          setSelectedBranch(vehicleCategory);
          dispatch({
            type: "SearchMasterData",
            payload: {
              Account_ID: { ...LoadData?.AccountData },
              Load_Manager: { ...LoadData?.Load_Manager },

              Loading_Name: {
                city: LoadData.From_City,
                latitude: LoadData.Loading_Latitude,
                longitude: LoadData.Loading_Longitude,
              },
              Unloading_Name: {
                city: LoadData.To_City,
                latitude: LoadData.Unloading_Latitude,
                longitude: LoadData.Unloading_Longitude,
              },
              // Payment_Type: { _id: LoadData?.Payment_Type?._id },
            },
          });

          // LoadData.Payment_Type = LoadData?.Payment_Type?.Name
          LoadData.Account_ID = LoadData?.AccountData?.Search_Value;
          LoadData.Load_Manager = LoadData?.Load_Manager?.FullName;
          setAllFieldsData(LoadData);
        } else if (TypeOfPortal === "Copy") {
          let LoadData = { ...data?.loadByID[0] };
          LoadData.UserId = "";
          LoadData.Loading_Date = "";
          LoadData.Load_Live_Duration = "";
          LoadData.Load_Manager = "";
          LoadData.Rate_per = "";
          LoadData.No_Of_Vehicels_Required = "";
          LoadData.Target_Price = "";
          LoadData.Notes = "";
          LoadData.Loading_Time = "";
          LoadData.Load_Post_Type = "";
          LoadData.Vehicle_Category = [];

          // LoadData.Payment_Type = LoadData?.Payment_Type?.Name

          setSelectedBranch({});
          setAllFieldsData(LoadData);
        }
      });
    } else {
      setAllFieldsData({
        Post_Frequency: "One Time",
        Over_Dimension_Cargo: "No",
        Load_Type: "FTL",
        No_Of_Vehicels_Required: 1,
        Rate_per: "Per Vehicle",
        Payment_Percentage: 90,
        Load_Live_Duration: "18hr",
        Load_Post_Type: "Open Load",
        Loading_Date: GetTodaysDateINdmy(),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddata]);

  const toggleBidModal = () => {
    setShowBidModal(!showBidModal);
  };

  useEffect(() => {
    let res = hasAnyVehicle(selectedBranches);
    setIsVehicleCateSelected(res);
  }, [selectedBranches]);

  useEffect(() => {
    if ((TypeOfPortal !== "Add" || TypeOfPortal === "Copy") && TypeOfPortal !== "Delete" && fielddata?._id) {
      GetLoadById({
        variables: {
          ID: fielddata?._id,
        },
      }).then(({ data }) => {
        let LoadData = { ...data?.loadByID[0] };
        if (LoadData.Loading_Date) {
          LoadData.Loading_Date = IsoToDateWithoutTime(LoadData.Loading_Date);
        }
        setTotalWeight(data?.loadByID[0]?.Total_Weight);
        // setLoadPostType(data?.loadByID[0]?.Load_Post_Type)

        let vehicleCategory = transformArrayToObj(LoadData?.VehicleCategoryGroupData);

        setSelectedBranch(vehicleCategory);
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              Account_ID: { ...LoadData?.AccountData },
              Load_Manager: { ...LoadData?.Load_Manager },
              Loading_Name: {
                city: LoadData.From_City,
                latitude: LoadData.Loading_Latitude,
                longitude: LoadData.Loading_Longitude,
              },
              Unloading_Name: {
                city: LoadData.To_City,
                latitude: LoadData.Unloading_Latitude,
                longitude: LoadData.Unloading_Longitude,
              },
            },
            // Payment_Type: { _id: LoadData?.Payment_Type?._id },
          },
        });
        // LoadData.Payment_Type = LoadData?.Payment_Type?.Name
        LoadData.Account_ID = LoadData?.AccountData?.Search_Value;
        LoadData.Load_Manager = LoadData?.Load_Manager?.FullName;
        setAllFieldsData(LoadData);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddata]);

  function hasAnyVehicle(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && Array.isArray(obj[key]) && obj[key].length > 0) {
        return true;
      }
    }
    return false;
  }

  function transformArrayToObj(arr) {
    const result = {};
    arr?.forEach((item) => {
      // Use the _id of the vehicle type as the key
      result[item._id] = item.VehicleCategory.map((cat) => ({
        _id: cat._id,
        Name: cat.Name,
      }));
    });
    return result;
  }

  function mergeVehicleInfo(objectWithNames, vehicleTypeInfoArray) {
    let result = [];

    vehicleTypeInfoArray?.forEach((vehicleType) => {
      const key = vehicleType._id;

      // Check if the key exists in objectWithNames and the array is not empty
      if (objectWithNames.hasOwnProperty(key) && objectWithNames[key]?.length > 0) {
        let newItem = {
          VehicleType: vehicleType.Vehicle_Type,
          VehicleCategory: objectWithNames[key],
        };

        result.push(newItem);
      }
    });

    return result;
  }

  useEffect(() => {
    if (Object.keys(selectedBranches).length > 0) {
      let mergedArray = mergeVehicleInfo(selectedBranches, vehicleCategoryData?.searchVehicleTypeMasters);

      setShowVehicleCategory(mergedArray);
    }
  }, [selectedBranches, vehicleCategoryData]);

  useEffect(() => {
    let rows = fielddataRedux["My_Loads"]?.Selected_Rows;
    setSelectedRows(rows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddataRedux]);

  useEffect(() => {
    if (FormDataFromRedux && FormDataFromRedux.hasOwnProperty(Form_Key)) {
      setalldata(FormDataFromRedux[Form_Key]);
    }
  }, [FormDataFromRedux]);

  const AddLoadLoadingState = CreateLoads || DeleteLoads || EditLoading ? true : false;

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  useEffect(() => {
    if (allFieldsData && allFieldsData.Auction_Time) {
      setLoadType("Auction Load");
    } else if (allFieldsData && allFieldsData.Load_Live_Duration) {
      setLoadType("Open Load");
    }
    if (allFieldsData && allFieldsData.Notes) {
      setNotesdata(allFieldsData.Notes);
    }
  }, [allFieldsData]);

  const submit = async (close) => {
    let data = { Notes: notesdata, Load_Post_Type: loadType, ...fileData };

    let vehicleId = [];

    if (TypeOfPortal !== "Delete") {
      for (let key in alldata) {
        data = {
          ...data,
          ...alldata[key],
        };
      }

      if (data?.Loading_Date) {
        data.Loading_Date = convertToISO(data?.Loading_Date);
      }
      if (
        !isVehicleCateSelected &&
        !vehicleId?.length &&
        FormData.fielddata.Load_Type.Load_Type !== "PTL (Part Load)"
      ) {
        WarningToast("Please Select vehicle category");
        return;
      }

      if (data.Post_Frequency === "One Time") {
        delete data.Load_Live_Days;
      }
      if (data.Post_Frequency === "Daily" && data.Load_Live_Days === "") {
        WarningToast("Please Select Load Live Days ");
        return;
      }
      if (FormData.fielddata.Load_Type.Load_Post_Type === "Fixed Load" && !FormData.fielddata.Load_Type.Target_Price) {
        WarningToast("Please Fill Target Price");
        return;
      }
      if (FormData.fielddata.Load_Type.Load_Type === "PTL (Part Load)") {
        delete data?.Vehicle_Category;
      }
      if (!data.No_Of_Vehicels_Required) {
        delete data.No_Of_Vehicels_Required;
      }
      let MasterData = FormDataFromRedux?.MasterData[Form_Key];
      console.log(MasterData);
      data = {
        ...data,
        From_City: MasterData?.Loading_Name?.city || MasterData?.Loading_Name?.locality,
        Loading_Latitude: MasterData?.Loading_Name?.latitude,
        Loading_Longitude: MasterData?.Loading_Name?.longitude,
        To_City: MasterData?.Unloading_Name?.city || MasterData?.Unloading_Name?.locality,
        Unloading_Latitude: MasterData?.Unloading_Name?.latitude,
        Unloading_Longitude: MasterData?.Unloading_Name?.longitude,
      };
      for (let key in selectedBranches) {
        if (selectedBranches.hasOwnProperty(key) && key !== "SingleMultiSelectRows") {
          if (selectedBranches[key]) {
            selectedBranches[key].forEach((item) => {
              if (item._id) {
                vehicleId.push(item._id);
              }
            });
          }
        }
      }
      data.Vehicle_Category = vehicleId;
      // data.Length_Category = LengthId;

      data.Account_ID = FormDataFromRedux?.MasterData[Form_Key]?.Account_ID?._id;
      data.UserId = FormDataFromRedux?.MasterData[Form_Key]?.Account_ID?.UserId;
      data.Load_Manager = FormDataFromRedux?.MasterData[Form_Key]?.Load_Manager?._id;
    }

    if (TypeOfPortal === "Edit" || modifiedTypeOfPortal === "Edit Load") {
      delete data.createdAt;
      delete data.id;
      delete data.updatedAt;
      delete data.__typename;
      if (data.Load_Live_Duration === null) {
        delete data.Load_Live_Duration;
        delete data.Target_Price;
        delete data.Accept_Bids;
      }
      if (data.Auction_Date === null) {
        delete data.Auction_Date;
        delete data.Auction_Time;
        delete data.Expected_Price;
        delete data.Load_Manager;
        delete data.No_Of_Vehicels_Required;
      }
    }

    if (TypeOfPortal === "Edit" || modifiedTypeOfPortal === "Edit Load") {
      if (allFieldsData?.Load_Manager === "") {
      }
      await editLoad({
        variables: { id: allFieldsData._id, userInput: data },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Load Edited Sucess");
          Closeformfunction();
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else if (TypeOfPortal === "Delete" || modifiedTypeOfPortal === "Delete Load") {
      const ArrayOfID = selectedRows.map((obj) => obj._id);
      console.log('"delete"hbguyjhbjhb mjnbvjk vbgnkbghkhoohjjibkhj ');
      await deleteLoads({
        variables: { idsToDelete: ArrayOfID },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Load Deleted");
          settoggle(false);
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else {
      delete data.No_Of_Vehicles;

      // data.No_Of_Vehicels_Required=Number(data)
      console.log(data);
      createLoad({
        variables: {
          UserId: FormDataFromRedux?.MasterData[Form_Key]?.Account_ID?.UserId,
          createInput: data,
        },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Load added");
          if (close === "Close") {
            setTimeout(() => {
              Closeformfunction();
            }, 500);
          }
        })
        .catch((err) => {
          ErrorToast("Something went wrong! Please Check fields and try again.");
        });
    }
    if (error) {
      ErrorToast(error.message);
    }
  };

  const clearForm = () => {
    setAllFieldsData({});
    setSelectedBranch({});
    dispatch({
      type: "ClearData",
      payload: { data: {}, MultiSelectedRows: {} },
    });
    ClearSpecificForm(dispatch, Form_Key);
  };

  // eslint-disable-next-line
  const Closeformfunction = () => {
    clearForm();
    ParentPortalCloseFunction();
    settoggle(false);
  };

  const handleOpenSelectionModal = () => {
    setOpenSelectionModal(true);
  };
  if (TypeOfPortal === "Audit Load" || modifiedTypeOfPortal === "Audit Load") {
    submit();
    return <></>;
  }

  const SaveAndClose = () => {
    submit("Close");
  };

  if (TypeOfPortal === "Delete" || modifiedTypeOfPortal === "Delete Load") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>
        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={() => {
            Validate_handleSubmit(submit);
          }}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={AddLoadLoadingState}
        />
      </Reactportal>
    );
  }

  return (
    <Reactportal
      open={toggle}
      onClose={Closeformfunction}
      TypeOfPortal={modifiedTypeOfPortal}
      TypeOfId={"Load Id :"}
      //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
    >
      <div className="Allloadmaindiv">
        {Loadfilds.map((e) => {
          const showBidButton = e.fields.some((field) => field.name === "Bid") && modifiedTypeOfPortal === "Bid Load";
          return (
            <div key={e.id} style={{ margin: "10px" }}>
              <Addloadsection
                inputfields={e.fields}
                Type={e.name}
                isVehicleCateSelected={isVehicleCateSelected}
                fielddata={allFieldsData}
                TypeOfPortal={TypeOfPortal}
                ShowVehicleCategory={showVehicleCategory}
                handleOpenSelectionModal={() => handleOpenSelectionModal()}
                formkey={Form_Key}
                setAllFieldsData={setAllFieldsData}
                onErrorsChange={handleErrorsChange}
                setFirstLoad={setFirstLoad}
              />
              {showBidButton && <Button name="BidButton" text={"Bid Per MT"} action={toggleBidModal}></Button>}
            </div>
          );
        })}

        {showBidModal && <BidDetails show={showBidModal} totalWeight={totalWeight} setShowModal={toggleBidModal} />}

        {openSelectionModal && (
          <FirstSectionModal
            show={openSelectionModal}
            query={Get_Vehicle_Category_By_Id}
            getSelectedBranches={(data) => {
              setSelectedBranch(data);
            }}
            selectedBranches={selectedBranches}
            data={vehicleCategoryData && vehicleCategoryData.searchVehicleTypeMasters}
            fielddata={selectedBranches}
            TypeOfPortal={"Vehicle Category"}
            setModal={() => setOpenSelectionModal(false)}
          />
        )}

        <div className="NoteImageHeading">
          <div>
            <p className="NoteLable">Notes: </p>
          </div>
          <div>
            <p className="NoteLable">Documents: </p>
          </div>
        </div>
        <div className="NoteAndImages">
          <div className="moredetailsection">
            <textarea
              name="note"
              value={notesdata}
              placeholder="Please Enter Notes If any other information needs to be provided"
              onChange={(e) => setNotesdata(e.target.value)}
            ></textarea>
            {/* </div> */}
          </div>
          <div className="loadImages">
            <DocumentuploadSection
              fielddata={allFieldsData}
              allFieldsData={alldata}
              data={DocUpload.fields}
              TypeOfPortal={TypeOfPortal}
              LoadForm={true}
              formkey={Form_Key}
              formReference={formRef}
              values={allFieldsData}
            />
          </div>
        </div>

        {showCopyLoadModal && (
          <Addload
            show={showCopyLoadModal}
            id={""}
            TypeOfPortal={"Copy"}
            submitType={"Save"}
            onKeyDown={""}
            ParentPortalCloseFunction={() => setShowCopyLoadModal(false)}
          />
        )}
      </div>
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={() => {
          Validate_handleSubmit(submit);
        }}
        submitType={submitType}
        TypeOfPortal={modifiedTypeOfPortal}
        Form_key={Form_Key}

        // SaveAndClose={TypeOfPortal === "Add" ? SaveAndClose : submit}
        {...(isTMSLoadBoardPage
          ? {}
          : {
              SaveAndClose:
                TypeOfPortal === "Add"
                  ? () => {
                      Validate_handleSubmit(SaveAndClose);
                    }
                  : () => {
                      Validate_handleSubmit(submit);
                    },
            })}
        handleFileDelete={() => setShowCopyLoadModal(true)}
        handleformclose={() => {
          Closeformfunction();
          settoggle(!toggle);
        }}
        loadingState={AddLoadLoadingState}
      />
    </Reactportal>
  );
};
export default memo(AddMyload);
